import React from 'react';
import Header from '../../components/ui/Header';
import HeroSearchSection from './components/HeroSearchSection';
import FeaturedPropertiesCarousel from './components/FeaturedPropertiesCarousel';
import NeighborhoodIntelligence from './components/NeighborhoodIntelligence';
import MarketInsightsDashboard from './components/MarketInsightsDashboard';
import TrustSignalsSection from './components/TrustSignalsSection';
import FooterSection from './components/FooterSection';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        <HeroSearchSection />
        <FeaturedPropertiesCarousel />
        <NeighborhoodIntelligence />
        {/* <MarketInsightsDashboard /> */}
        <TrustSignalsSection />
      </main>
      
      <FooterSection />
    </div>
  );
};

export default Homepage;